import { addFilter, applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'
import { QueryClient, QueryClientProvider } from 'react-query'
import ExtraServices from './ExtraServices'
import SelectExtraServices from './ActivityExtraServices'

/**
 * Enrich the extraServices payload with service_id for inventory tracking.
 * Core builds cart.extraServices from state but strips service_id; we restore it here
 * so the PHP inventory system can record which service was booked.
 */
addFilter('wptravelengine.tripBookingModal.cart.subtotalReservations', 'wptravelengineExtraServices', (subtotalReservations, state) => {
    const { summary: { extraServices } } = state
    if (!extraServices?.length) return subtotalReservations

    const enriched = extraServices
        .filter(s => s.qty > 0)
        .map(s => ({
            id: s.id,
            service_id: s.service_id ?? 0,
            quantity: s.qty,
        }))

    return { ...subtotalReservations, extraServices: enriched }
}, 10, 2)

addFilter('wptravelengine.tripBookingModal.stepFormTabs', 'wptravelengineExtraServices', (tabs, props) => {
    if (tabs.length > 2) {
        const shouldInclude = applyFilters('wptravelengine.extraServices.includeStep', true, props)
        if (!shouldInclude) return tabs

        const queryClient = new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: 0,
                    refetchOnWindowFocus: false,
                }
            }
        })
        const extraServicesTab = {
            id: 'extra-services',
            title: wteL10n?.l10n?.extraServicesTitle || __('Extra Services', 'wp-travel-engine'),
            component: <QueryClientProvider client={queryClient}><ExtraServices {...props} /></QueryClientProvider>,
            icon: <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.7918 11.3334V9.33341M14.7918 9.33341H1.4585M14.7918 9.33341H8.12516V6.00008H12.7918C13.3223 6.00008 13.831 6.21079 14.206 6.58587C14.5811 6.96094 14.7918 7.46965 14.7918 8.00008V9.33341ZM1.4585 5.33341V11.3334M3.4585 6.00008C3.4585 6.3537 3.59897 6.69284 3.84902 6.94289C4.09907 7.19294 4.43821 7.33341 4.79183 7.33341C5.14545 7.33341 5.48459 7.19294 5.73464 6.94289C5.98469 6.69284 6.12516 6.3537 6.12516 6.00008C6.12516 5.64646 5.98469 5.30732 5.73464 5.05727C5.48459 4.80722 5.14545 4.66675 4.79183 4.66675C4.43821 4.66675 4.09907 4.80722 3.84902 5.05727C3.59897 5.30732 3.4585 5.64646 3.4585 6.00008Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            enabled: props?.trip?.trip_extra_services?.length
        }
        const existingIndex = tabs.findIndex(tab => tab.id === 'extra-services')
        if (existingIndex !== -1) {
            tabs.splice(existingIndex, 1, extraServicesTab)
        } else {
            tabs.splice(2, 0, extraServicesTab)
        }
    }
    return tabs
}, 11, 2)

const activityQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            refetchOnWindowFocus: false,
        }
    }
})

const ActivityExtraServices = (props) => (
    <QueryClientProvider client={activityQueryClient}>
        <SelectExtraServices {...props} />
    </QueryClientProvider>
)

addFilter('wptravelengine.activity.add_ons', 'wptravelengineExtraServices', (addOns) => {
    return { ...addOns, extraServices: ActivityExtraServices }
}, 12, 1)